import { render, staticRenderFns } from "./suffixIcon-editor.vue?vue&type=template&id=bef2ffc8&scoped=true&"
import script from "./suffixIcon-editor.vue?vue&type=script&lang=js&"
export * from "./suffixIcon-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bef2ffc8",
  null
  
)

export default component.exports